module.exports = __webpack_public_path__ + "media/anime_wow_sound_effect.031214d4.mp3";